import {
  MOUNT,
  ON_INPUT_CHANGE,
  ON_ENTER,
  ON_SKU_CHANGE,
  CLEAR_SKU,
  CLEAR_SEARCH,
  CLEAR_TABLE_FILTER,
  CLEAR_TABLE_SORT,
  UPDATE_SKU,
  UPDATE_SEARCH,
  UPDATE_TABLE_FILTER,
  UPDATE_TABLE_SORT,
  FETCH_PRODUCT_SKUS,
  FETCH_PRODUCT_SKUS_START,
  FETCH_PRODUCT_SKUS_SUCCESS,
  FETCH_PRODUCT_SKUS_ERROR,
  FETCH_GREENLIGHT_REPORT,
  FETCH_GREENLIGHT_REPORT_START,
  FETCH_GREENLIGHT_REPORT_SUCCESS,
  FETCH_GREENLIGHT_REPORT_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const mount = ({sku, tableFilter, tableSort}) => ({ type: MOUNT, sku, tableFilter, tableSort })
const onInputChange = (value) => ({ type: ON_INPUT_CHANGE, value })
const onEnter= (value) => ({ type: ON_ENTER, value })
const onSkuChange = (value) => ({ type: ON_SKU_CHANGE, value })
const clearSku = () => ({ type: CLEAR_SKU })
const clearSearch = () => ({ type: CLEAR_SEARCH })
const clearTableFilter = () => ({ type: CLEAR_TABLE_FILTER})
const clearTableSort = () => ({ type: CLEAR_TABLE_SORT})
const updateSku = (value) => ({ type: UPDATE_SKU, value })
const updateSearch = (value) => ({ type: UPDATE_SEARCH, value })
const updateTableFilter = (value) => ({ type: UPDATE_TABLE_FILTER, value})
const updateTableSort = (value) => ({ type: UPDATE_TABLE_SORT, value})
const fetchProductSkus = (value) => ({ type: FETCH_PRODUCT_SKUS, value })
const fetchProductSkusStart = () => ({ type: FETCH_PRODUCT_SKUS_START })
const fetchProductSkusSuccess = () => ({ type: FETCH_PRODUCT_SKUS_SUCCESS })
const fetchProductSkusError = (error) => ({ type: FETCH_PRODUCT_SKUS_ERROR, error })
const startFetchProductSkusAsync = buildAsyncAction(
  FETCH_PRODUCT_SKUS,
  FETCH_PRODUCT_SKUS_START,
  [FETCH_PRODUCT_SKUS_SUCCESS, FETCH_PRODUCT_SKUS_ERROR]
)
const fetchGreenlightReport = (sku, query) => ({ type: FETCH_GREENLIGHT_REPORT, query, sku  })
const fetchGreenlightReportStart = () => ({ type: FETCH_GREENLIGHT_REPORT_START })
const fetchGreenlightReportSuccess = () => ({ type: FETCH_GREENLIGHT_REPORT_SUCCESS })
const fetchGreenlightReportError = (error) => ({ type: FETCH_GREENLIGHT_REPORT_ERROR, error })
const startFetchGreenlightReport = buildAsyncAction(
  FETCH_GREENLIGHT_REPORT,
  FETCH_GREENLIGHT_REPORT_START,
  [FETCH_GREENLIGHT_REPORT_SUCCESS, FETCH_GREENLIGHT_REPORT_ERROR]
)

export {
  mount,
  onInputChange,
  onEnter,
  onSkuChange,
  clearSku,
  clearSearch,
  clearTableFilter,
  clearTableSort,
  updateSku,
  updateSearch,
  updateTableFilter,
  updateTableSort,
  fetchProductSkus,
  fetchProductSkusStart,
  fetchProductSkusSuccess,
  fetchProductSkusError,
  startFetchProductSkusAsync,
  fetchGreenlightReport,
  fetchGreenlightReportStart,
  fetchGreenlightReportSuccess,
  fetchGreenlightReportError,
  startFetchGreenlightReport,
}
